var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7e27601b5462ca5089d0533e63caaf9725d063a3"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";
import { RewriteFrames } from "@sentry/integrations";
import type { StackFrame } from "@sentry/types";

Sentry.init({
  dsn: "https://08241ecd094f4aca7795ecc8a4e0e371@o425239.ingest.us.sentry.io/4507579249131520",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Disable session replay for now
  replaysOnErrorSampleRate: 0,
  replaysSessionSampleRate: 0,

  integrations: [
    new RewriteFrames({
      iteratee: (frame: StackFrame) => {
        if (frame.filename) {
          // Handle the specific app:///_next pattern
          frame.filename = frame.filename
            .replace(/^app:\/\/\/_next/, '/_next')
            .replace(/^app:\/\//, '')
            .replace(/^~\/_next/, '/_next');
        }
        return frame;
      },
    }),
  ],
});
